import { defaultAxiosInstance } from "./defaultInstance";
import { ACCESS_ME_PATH } from "./permissionEvents";

// 권한 관리 API (Catachrank-API spec 5.5, prefix /api/v1/admin/access). 응답은 { status, message, data } 이고 data만 돌려준다.
const BASE = "/admin/access";
const enc = encodeURIComponent;

/** R-MGMT-01 내 역할·실효 권한 → { adminUserId, roles, permissions, mode } */
export const fetchMyAccess = async () => {
  const response = await defaultAxiosInstance.get(ACCESS_ME_PATH);
  return response.data?.data;
};

/** R-MGMT-02 카탈로그 → [{ domain, permissions: [{ key, description, enforceAlways, screens?: string[], hidden?: boolean }] }]
 *  screens/hidden 은 이전 API 에 없을 수 있다 — 표시 처리는 utils/permissionScreens.splitCatalog. */
export const fetchPermissionCatalog = async () => {
  const response = await defaultAxiosInstance.get(`${BASE}/permissions`);
  return response.data?.data ?? [];
};

/** R-MGMT-03 기능별 보기 → { key, admins: [{ adminUserId, name, email, effective, source, roleKeys, override }] } */
export const fetchPermissionAdmins = async (key) => {
  const response = await defaultAxiosInstance.get(`${BASE}/permissions/${enc(key)}/admins`);
  return response.data?.data;
};

/** R-MGMT-04 기능별 토글. effect: ALLOW | DENY | INHERIT(개인 예외 제거) */
export const setPermissionOverride = async (key, adminUserId, { effect, expiresAt, reason }) => {
  const body = { effect, reason };
  if (expiresAt) body.expiresAt = expiresAt;
  const response = await defaultAxiosInstance.put(
    `${BASE}/permissions/${enc(key)}/admins/${enc(adminUserId)}`,
    body,
  );
  return response.data?.data;
};

/** R-MGMT-05 사람별 보기 → { adminUserId, name, email, roles: [{ roleKey, name }], permissions: [...] } */
export const fetchAdminAccess = async (adminUserId) => {
  const response = await defaultAxiosInstance.get(`${BASE}/admins/${enc(adminUserId)}`);
  return response.data?.data;
};

/** R-MGMT-06 역할 배정 교체 */
export const replaceAdminRoles = async (adminUserId, { roleKeys, reason }) => {
  const response = await defaultAxiosInstance.put(`${BASE}/admins/${enc(adminUserId)}/roles`, {
    roleKeys,
    reason,
  });
  return response.data?.data;
};

/** R-MGMT-07 역할 목록 → [{ roleKey, name, description, isSystem, permissionKeys, memberCount }] */
export const fetchRoles = async () => {
  const response = await defaultAxiosInstance.get(`${BASE}/roles`);
  return response.data?.data ?? [];
};

export const createRole = async ({ roleKey, name, description, reason }) => {
  const body = { roleKey, name, reason };
  if (description) body.description = description;
  const response = await defaultAxiosInstance.post(`${BASE}/roles`, body);
  return response.data?.data;
};

export const updateRole = async (roleKey, { name, description, reason }) => {
  const response = await defaultAxiosInstance.patch(`${BASE}/roles/${enc(roleKey)}`, {
    name,
    description,
    reason,
  });
  return response.data?.data;
};

export const deleteRole = async (roleKey, reason) => {
  const response = await defaultAxiosInstance.delete(`${BASE}/roles/${enc(roleKey)}`, {
    params: { reason },
  });
  return response.data?.data;
};

/** R-MGMT-08 역할의 권한 교체 */
export const replaceRolePermissions = async (roleKey, { permissionKeys, reason }) => {
  const response = await defaultAxiosInstance.put(`${BASE}/roles/${enc(roleKey)}/permissions`, {
    permissionKeys,
    reason,
  });
  return response.data?.data;
};

/** R-MGMT-09 변경 이력 → { items, page, size, total }. 빈 값 필터는 보내지 않는다. */
export const fetchAuditLogs = async (params = {}) => {
  const query = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""),
  );
  const response = await defaultAxiosInstance.get(`${BASE}/audit-logs`, { params: query });
  return response.data?.data;
};
